<div>
  <h5
    style="font-weight: 400; margin-top: 1rem; padding: 2rem 2rem 0 2rem; font-size: 1rem"
  >
    {{ 'utilities.filesControl.history.description' | translate }}
  </h5>
  <div class="filters">
    <div class="col-md-3">
      <div class="form-group column">
        <h6 class="card-title">
          {{ 'Operación' | translate }}
        </h6>
        <div>
          <ng-select
            class="selectpicker"
            [placeholder]="'Operación' | translate"
            [items]="operations"
            [closeOnSelect]="false"
            [(ngModel)]="selectedOperations"
          ></ng-select>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group column">
        <h6 class="card-title">
          {{ 'Usuario' | translate }}
        </h6>
        <div>
          <ng-select
            class="selectpicker"
            [placeholder]="'Usuario' | translate"
            [items]="users"
            [closeOnSelect]="false"
            [(ngModel)]="selectedUsers"
            bindLabel="label"
            bindValue="value"
          ></ng-select>
        </div>
      </div>
    </div>
    <button
      style="padding: 5px 30px; width: 110px; height: 2rem; margin-left: 5rem"
      type="button"
      class="btn btn-primary"
      (click)="setFilters()"
      [disabled]="isLoading"
    >
      {{ 'record.filter.filter' | translate }}
    </button>
    <button
      style="padding: 5px 0px; width: 110px; height: 2rem; margin-left: 1rem"
      type="button"
      class="btn btn-outline-primary"
      (click)="cleanFilters()"
      [disabled]="isLoading"
    >
      {{ 'record.filter.cleanFilters' | translate }}
    </button>
  </div>
  <div style="padding: 2rem">
    <div>
      <div>
        {{
          'record.recordsCount'
            | translate
              : { count: tableData?.length || '0', total: collectionSize }
        }}
      </div>
    </div>
    <div class="d-flex justify-content-center loader" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div>
      <table class="table table-striped" *ngIf="!isLoading && tableData?.length > 0">
        <thead>
          <tr>
            <th scope="col">
              {{ 'utilities.filesControl.history.operation' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.user' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.date' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.origin' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.destiny' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style="height: 50px; overflow: scroll"
            *ngFor="let data of tableData"
          >
            <td>{{ data.operation }}</td>
            <td>{{ data.user }}</td>
            <td>{{ formatDateTable(data.date) }}</td>
            <td>{{ data.sender }}</td>
            <td>{{ data.receivers }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="tableData?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>

    <div class="d-flex justify-content-center p-2" *ngIf="tableData?.length > 0">
      <ngb-pagination
        [collectionSize]="collectionSize"
        [(page)]="page"
        [pageSize]="pageSize"
        [rotate]="true"
        [maxSize]="5"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="refreshData()"
      >
      </ngb-pagination>

      <!--
      <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
        <option [ngValue]="2">2 items per page</option>
        <option [ngValue]="4">4 items per page</option>
        <option [ngValue]="6">6 items per page</option>
      </select>
      -->
    </div>
  </div>
</div>
